<template>
  <div class="markup-tables flex">
    <va-card class="flex mb-4">
      <va-card-title style="font-size: 1.5rem;">Image Grid</va-card-title>
      <va-card-content>
        <div class="row">
          <va-card class="flex xs3 md3 offset--md1" style="margin-bottom: 1.5rem;" v-for="image in gridImages" :key="image.uid">
            <va-card-title>
              {{ image.name }}
              <br />{{ image.created_at }}
            </va-card-title>
            <va-card-content>
              <router-link :to="{ name: 'file', params: { id, sessionId: session_id, fileId: image.image_id }}">
                <img style="width: 100%;" :src="image.jpg" />
              </router-link>
            </va-card-content>
          </va-card>
        </div>
      </va-card-content>
    </va-card>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'

export default {
  mounted: async function () {
    if (this.selectedItems.length > 0) {
      this.loader = this.$loading.show()
      this.gridImages = []
      try {
        const headers = {
          Authorization: `Bearer ${this.token}`
        }
        await Promise.all(this.selectedItems.map(async (selectedItem) => {
          const images = await axios.get(`${process.env.VUE_APP_API_URL}/api/identifiers/${this.id}/sessions/${this.session_id}/images/${selectedItem.uid}`, { headers })
          const image_id = images.data.image.uid

          if (image_id) {
            const image = await axios.get(`${process.env.VUE_APP_API_URL}/api/identifiers/${this.id}/sessions/${this.session_id}/images/${selectedItem.uid}/download`, { headers })
            this.gridImages.push({
              uid: selectedItem.uid,
              image_id: image_id,
              jpg: image.data.image.jpg,
              name: image.data.image.name,
              created_at: moment(image.data.image.created_at).format('YYYY-MM-DD hh:mm a')
            })
          }
        }))
        this.gridImages = _.orderBy(this.gridImages, ['created_at'], ['desc'])
        this.loader.hide()
      } catch (error) {
        this.loader.hide()
        this.$router.push({ name: 'login', query: { redirect: `/pages/identifiers/${this.id}/sessions/${this.session_id}/grid` } })
      }
    } else {
      this.$router.push({ name: 'sessions' })
    }
  },
  data () {
    return {
      loader: null,
      id: this.$route.params.id,
      session_id: this.$route.params.sessionId,
      token: this.$store.state.token,
      selectedItems: this.$store.state.selectedItems,
      selectedItemsMode: this.$store.state.selectedItemsMode,
      gridImages: []
    }
  },
  computed: {
  },
  methods: {
  },
}
</script>

<style lang="scss">
  .markup-tables {
    .table-wrapper {
      overflow: auto;
    }

    .va-table {
      width: 100%;
    }
  }

  .table-example--pagination {
    text-align: center;
    text-align: -webkit-center;
    padding-top: 1rem;
  }
</style>
